module.exports = __webpack_public_path__ + "img/bacon.9d2af67e.svg";